export default {
  homeUi: {
    seo: {
      title: 'AQUAMARINA TOURS | Paseos en Barco, Lancha y Jeep en Paraty',
      description: 'AQUAMARINA TOURS - Experiencias oceánicas únicas en Paraty, RJ. Paseos en barco, lanchas privadas, jeep tour por la Costa Verde, snorkel y buceo.',
    },
    hero: {
      subtitleTail: 'te esperan en las aguas cristalinas de Paraty.',
      showcaseBadge: 'DESTACADO AQUAMARINA',
      showcaseCta: 'Ver paseo',
      showcaseAria: 'Ver detalles de {{title}}',
      experiencesAria: 'Experiencias disponibles',
      experiences: {
        schooner: 'BARCO',
        boat: 'LANCHA',
        jeep: 'JEEP',
        diving: 'BUCEO',
      },
      featuredAria: 'Paseos destacados',
      route: 'PARATY · COSTA VERDE · BRASIL',
      scrollCue: 'DESLIZA PARA EXPLORAR',
    },
    why: {
      safety: 'Tripulación capacitada, chalecos salvavidas para todos los pasajeros y embarcaciones inspeccionadas regularmente por la Marina de Brasil.',
      guides: 'Nuestros guías conocen cada rincón de Paraty — desde las playas escondidas hasta las historias detrás de cada isla.',
      boats: 'Barcos cómodos, lanchas modernas y jeeps 4x4 revisados. Equipo de snorkel y buceo de primera calidad.',
      price: 'Sin cargos ocultos. El precio del sitio es el precio final. Hasta 3 cuotas con tarjeta.',
    },
    bolivia: {
      bgAlt: 'Salar de Uyuni, Bolivia',
      slideAlt: 'Expedición Salar de Uyuni',
      included: {
        accommodation: 'Alojamiento 2 Noches',
        meals: 'Todas las Comidas',
        transport: 'Transporte 4x4',
        guide: 'Guía Experto',
        sunset: 'Atardecer en el Salar',
        flamingos: 'Flamencos y Lagunas',
      },
    },
    trust: {
      cadasturAlt: 'Cadastur - Registro Nacional de Prestadores de Servicios Turísticos de Brasil',
      tripadvisorAlt: 'Calificación de 5 estrellas en Tripadvisor',
      tripadvisorText: 'Certificado de Excelencia',
      googleAlt: 'Calificación de 4.9 en Google',
      googleText: '4.9/5 en Google Reviews',
      supportName: 'Atención al cliente',
      supportAlt: 'Atención al cliente por WhatsApp',
      supportText: 'Soporte 24 h',
    },
    contact: {
      mapTitle: 'Mapa de Paraty',
    },
    testimonials: {
      ratingAria: '{{rating}} de 5',
    },
    footer: {
      links: 'Enlaces',
      privacy: 'Privacidad',
      cookies: 'Cookies',
      terms: 'Términos',
      reservations: 'Reservas',
      cancellations: 'Cancelaciones',
    },
    cart: {
      floatingAria: 'Carrito de paseos',
    },
    countdown: {
      aria: 'Cuenta regresiva: {{time}}',
    },
    marquee: {
      aria: 'Nuestras experiencias',
    },
  },
};
